var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-right_svg__nc-icon-wrapper",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-color": "color-2",
    d: "M.5 8.5h15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.5l5 5-5 5"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiI+PHRpdGxlPmFycm93IHJpZ2h0PC90aXRsZT48ZyBjbGFzcz0ibmMtaWNvbi13cmFwcGVyIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9IiNmZmYiIHN0cm9rZT0iI2ZmZiI+PGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHgxPSIwLjUiIHkxPSI4LjUiIHgyPSIxNS41IiB5Mj0iOC41IiBkYXRhLWNvbG9yPSJjb2xvci0yIi8+IDxwb2x5bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBwb2ludHM9IjEwLjUsMy41IDE1LjUsOC41IDEwLjUsMTMuNSAiLz48L2c+PC9zdmc+Cg==";
export { SvgArrowRight as ReactComponent };